import { render, staticRenderFns } from "./notificationEdit.vue?vue&type=template&id=c5c9307e"
import script from "./notificationEdit.vue?vue&type=script&lang=js"
export * from "./notificationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports